/* global axios */

export default {
  getEvents(accountId, contactId, params = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/contacts/${contactId}/events`, { params });
  },
};
